import React from 'react';
import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
type Props = {
  Left: any;
  Right: any;
};

const ChartLayout: React.FC<Props> = ({ Left, Right }) => {
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      <Box className={classes.segment} flex={0.65}>
        {Left}
      </Box>
      <Box className={classes.segment} flex={0.58} padding="0px 10px">
        <Box>{Right}</Box>
      </Box>
    </Box>
  );
};

const useStyles = makeStyles({
  container: {
    display: 'flex',
    flex: 1,
    flexFlow: 'wrap'
  },
  segment: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
  }
});
export default ChartLayout;
